import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { compareOfferTabs, getOfferTermLabel, PaymentFrequencyLabel } from 'common';
import { OfferBundleData } from '../offer-bundle.service';

interface RepaymentTab {
  offerBundle: OfferBundleData;
  term: string;
  paymentFrequency: string;
  active: boolean;
}

@Component({
    selector: 'ifa-repayment-navigator',
    templateUrl: './repayment-navigator.component.html',
    styleUrls: ['./repayment-navigator.component.scss'],
    standalone: false
})
export class RepaymentNavigatorComponent implements OnChanges {

  @Input() offerBundles: OfferBundleData[];
  @Input() currentOfferBundle: OfferBundleData;
  @Input() customerView: boolean;
  selectedBundle: string;
  tabs: RepaymentTab[];

  constructor(private _router: Router, private _route: ActivatedRoute) { }

  click(offerBundle: OfferBundleData) {
    let path = offerBundle.productCode.toLowerCase();
    let pathMode = this.customerView ? 'preview' : 'calculator';

    let uuid = this._route.snapshot.queryParamMap.get('uuid');
    this._router.navigate([`/${pathMode}/${path}`], { queryParams: { uuid: uuid, bundleId: offerBundle.bundleId } });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if(changes.currentOfferBundle)
      this.selectedBundle = changes.currentOfferBundle?.currentValue?.bundleId;

    if(changes.offerBundles || changes.currentOfferBundle)
      this.tabs = [...(this.offerBundles ?? [])]
        .sort(compareOfferTabs)
        .map(offerBundle => ({
          offerBundle,
          term: `${offerBundle.express ? 'express ' : ''}${getOfferTermLabel(Number(offerBundle.repayment))}`,
          paymentFrequency: PaymentFrequencyLabel.get(offerBundle.paymentFrequency),
          active: this.isCurrentBundle(offerBundle)
        }));
  }

  trackByBundleId(_index: number, tab: RepaymentTab): number {
    return tab.offerBundle.bundleId;
  }

  private isCurrentBundle(offerBundle: OfferBundleData): boolean {
    return offerBundle.bundleId === this.currentOfferBundle?.bundleId
      && offerBundle.productCode === this.currentOfferBundle.productCode
      && offerBundle.repayment === this.currentOfferBundle.repayment;
  }
}

